module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Promo01.ac9340fa.jpg";